import React from 'react';
import styles from './FullRankingList.module.scss';
import { renderMaxLengthText, renderMaxLengthTextWhitoutDots } from 'utils/renderMaxLengthText';
import backIcon from 'img/Back.png';
import { useJugadoresStatColumnTooltip } from 'containers/Mundial2026/WCMatchDetails/WCJugadores/hooks/useJugadoresStatColumnTooltip';

export const FullRankingList = ({
  title,
  statLabel,
  statAbbreviation,
  players,
  onBack,
  playerColumnLabel,
}) => {
  const { bindHeaderTooltip, headerTooltipPortal } = useJugadoresStatColumnTooltip();

  return (
  <div className={styles.wrapper}>
    <div className={styles.topBar}>
      <div className={styles.backArea}>
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          aria-label="Volver"
        >
          <img src={backIcon} alt="" aria-hidden="true" width={32} height={32} />
        </button>
      </div>
      <h2 className={styles.title}>{title}</h2>
    </div>

    <div className={styles.contentArea}>
      {statAbbreviation && statLabel && (
        <p className={styles.legend}>
          <span className={styles.legendAbbr}>{statAbbreviation}:</span>
          {` ${statLabel}`}
        </p>
      )}

      <div className={styles.table}>
        <div className={styles.tableHeader}>
          <span className={styles.colRank} />
          <span className={styles.colPlayer}>{playerColumnLabel}</span>
          <span className={styles.colGames}>#</span>
          <span
            className={styles.colStat}
            {...(statLabel ? bindHeaderTooltip(statLabel) : {})}
          >
            {statAbbreviation || 'G'}
          </span>
        </div>

        {players.map(player => (
          <div key={player.rank} className={styles.tableRow}>
            <span className={styles.colRank}>
              <span className={styles.rankNumber}>{player.rank}</span>
            </span>

            <span className={styles.colPlayer}>
              {player.flagUrl && (
                <span className={styles.flagWrap}>
                  <img
                    src={player.flagUrl}
                    alt={player.country}
                    className={styles.flagImg}
                  />
                </span>
              )}
              <span className={styles.playerName}>{renderMaxLengthText(player.name, 22)}</span>
            </span>

            <span className={styles.colGames}>
              <span className={styles.jerseyNumber}>
                {renderMaxLengthTextWhitoutDots(
                  player.jerseyNumber != null
                    ? `# ${player.jerseyNumber}`
                    : '',
                  5,
                )}
              </span>
            </span>
            <span className={styles.colStat}>{renderMaxLengthTextWhitoutDots(player.statValue != null ? String(player.statValue) : '—', 2)}</span>
          </div>
        ))}
      </div>
    </div>
    {headerTooltipPortal}
  </div>
  );
};
